module.exports = __webpack_public_path__ + "static/media/calendar1.25c088f9.png";